import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

/** @jsx jsx */
import { jsx } from '@emotion/core'

const propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  styles: PropTypes.object,
};

const ExternalLink = (props) => {
  const {text, url, styles} = props;

  return (
    <a
      target="_blank"
      href={url}
      rel="noopener noreferrer"
      css={styles ? styles : null}
    >
      {text}
    </a>
  );
};

ExternalLink.propTypes = propTypes;
export default ExternalLink;
